<template>
	<TwoColumns>
		<template #first>
			<div class="flex flex-col">
				<h2 class="w-full">
					Electric cars - EVerything you need to know
				</h2>
				<div class="space-y-5 text-lg text-gray-575">
					<p>
						Electric cars are becoming more and more popular, as
						people become increasingly interested in saving money on
						fuel and being environmentally friendly.
					</p>
					<p>
						While electric cars have been around for a while, they
						have typically been less affordable than traditional
						petrol-powered vehicles. However, this is changing, as
						electric cars are becoming more affordable for the
						average consumer.
					</p>
					<p>
						In addition, electric cars have many other benefits,
						such as being much cheaper to operate and maintain than
						petrol-powered cars. Electric cars also emit less
						tailpipe emissions than fuel-powered cars, with many
						consumers considering EVs an environmentally friendly
						option.
					</p>
					<p>
						As more people become interested in electric cars, it is
						likely that their popularity will continue to grow. If
						you’re new to the world of rechargeable cars, we have
						all the information you need to make the decision to
						switch.
					</p>
				</div>
			</div>
		</template>
		<template #second>
			<div class="mt-8 flex flex-col gap-8 lg:mt-0 lg:pl-10">
				<div v-for="(list, key) in Lists" :key="key">
					<h3 class="font-body font-medium">{{ list.head }}</h3>
					<div class="text-lg">{{ list.content }}</div>
					<div v-if="list.href" class="mt-8">
						<CarbarLink
							:href="list.href"
							target="_blank"
							:underline="false"
						>
							<CarbarButton
								:is-full-width="false"
								:is-outline="true"
								:is-mixed="true"
								@click="scrollTo(list.scrollTo)"
							>
								{{ list.link }}
							</CarbarButton>
						</CarbarLink>
					</div>
				</div>
			</div>
		</template>
	</TwoColumns>
</template>

<script setup>
import TwoColumns from '@/components/sections/TwoColumns.vue'
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'

const props = defineProps({
	icon: {
		type: String,
		default: 'img/common/ico-arrow_down.svg',
		required: false,
	},
})
const Lists = [
	{
		head: 'Your guide to everything EV',
		content:
			'Discover the benefits of owning an electric vehicle in Australia. Learn about costs, charging options, tax incentives, and more.',
		link: 'Learn all about EVs',
		href: 'https://www.carbar.com.au/blog/making-the-switch-your-guide-to-owning-an-electric-vehicle',
	},
	{
		head: 'Buying an electric vehicle',
		content:
			'Let us help you understand how to buy an electric car, what you need to look out for, and everything else to consider.',
		link: 'A guide to buying an EV',
		href: 'https://www.carbar.com.au/blog/buying-an-electric-vehicle',
	},
	{
		head: 'Subscribing an EV',
		content:
			"Rather than buying or leasing an electric vehicle, subscribers pay a monthly fee to have full access to the EV from the subscription company's fleet.",
		link: 'A guide to EV subscription',
		href: 'https://www.carbar.com.au/blog/everything-you-ever-wanted-to-know-about-electric-car-subscriptions',
	},
]
</script>
